import type {
  TrackingEvent,
  TrackingPayload,
  TrackPromotionParams,
} from '~/types/tracking'
import { resolvePageType } from '~/utils/tracking'
import useActivePromotion from '#layers/base/composables/tracking/useActivePromotion'

const usePromotionEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => {
  const { setActivePromotion } = useActivePromotion()
  const route = useRoute()

  return {
    trackPromotionSelect: (params: TrackPromotionParams) => {
      const { id, name, pageType, promoType, position, creativeNameSb } = params
      const resolvedPageType = pageType ?? resolvePageType(route)

      if (!resolvedPageType) {
        return
      }

      const promotion = {
        promotion_id: id,
        promotion_name: name,
        creative_name: `${resolvedPageType}_${promoType}`,
        creative_slot: `${promoType}_pos${position}`,
        creative_name_storyblok: creativeNameSb,
      }
      track('select_promotion', promotion)
      setActivePromotion(promotion)
    },

    trackPromotionView: (params: TrackPromotionParams) => {
      const { id, name, pageType, promoType, position, creativeNameSb } = params
      const resolvedPageType = pageType ?? resolvePageType(route)

      if (!resolvedPageType) {
        return
      }

      const promotion = {
        promotion_id: id,
        promotion_name: name,
        creative_name: `${resolvedPageType}_${promoType}`,
        creative_slot: `${promoType}_pos${position}`,
        creative_name_storyblok: creativeNameSb,
      }
      track('view_promotion', promotion)
    },
  }
}

export default usePromotionEvents
